import React from 'react'
import { withStyles } from '@material-ui/core/styles'



const styles = (theme => ({
    root:{
      color:'white',
      position:'absolute',
      left:'0',
      '&h1,h2,h3,h4,h5,h6':{
        margin:'10px'
      },
      zIndex:'999',
    },
    title2:{
      fontFamily: 'var(--font-sans)',
      fontWeight: '600',
      fontStyle: 'SemiBold',
      fontSize: '56px',
      lineHeight: '64px',
      letterSpacing: '-2%',
      textAlign: 'left',
      color: '#002857',
    },
    title3:{
      color:'#305178',
      fontFamily: 'var(--font-sans)',
      fontWeight: '400',
      fontStyle: 'Regular',
      fontSize: '20px',
      lineHeight: '30px',
      letterSpacing: '0%',
    }
})
)
let Textheader = (props) => {
   const {classes} = props
   return(
        <div className={`${classes.root} TitleHeader`}>
            <h1 className={classes.title2}>
                Educational
            </h1>
            <h6 className={classes.title3}>
                Check out our video training series and don&apos;t forget to<br /> subscribe to our YouTube channel!
            </h6>
        </div>
   )
}

export default withStyles(styles)(Textheader)
